<script setup>
import { ref, onMounted, watch, defineExpose, reactive, defineProps, defineEmits, inject } from "vue"
import { permission } from '@/utils/permission';
import i18n from "@/i18n"
import PreviewImg from "@/components/common/PreviewImg";
import { useRouter, useRoute } from "vue-router";
import usetablePageNation from "@/utils/hooks/usetablePageNation" //分页hooks
import useMessage from "@/utils/hooks/useMessage" //信息hooks
import Swal from "sweetalert2";
import { getProductsList, deleteProduct, getFileUrl, copyProduct, getProductsListV3, database_template_name_v3 } from "@/service"
import { getLangValue, makeQrCode } from "@/utils/common"; //获取后端语言
const props = defineProps({
    showSearch: {
        type: Boolean,
        default: false,
    },
})
const emits = defineEmits(['updateTabData'])
const tableInfo = ref([])
const fileList = ref([])
const router = useRouter()
const route = useRoute()
const loading = ref(false)
const showCharts = ref([false, false, false])
const activeImageSrc = ref('')
const showPreviewImg = ref(false)
const templateNameList = ref([]) // 所有模板信息
const tableType = ref(0) // 0 产品线 1 公开产品
// const checkedAll = ref(false) // 全选
// const visible = ref(false) // 雷达对比图
// const visibleInfo = ref({}) // 雷达信息
// const showCharts1 = inject('showCharts1') // 是否有图表展示
const selectedInfo = inject('selectedInfo') //表格选中的产品
const table_head = ref([
    { label: getLangValue("product-management", "title"), width: '15%',  sortable: true},
    { label: getLangValue("product-template", "publicType"), width: '11%', },
    { label: getLangValue("product-management", "status"), width: '11%', },
    { label: getLangValue("product-template", "color"), width: '11%', },
    { label: getLangValue("product-template", "inventory"), width: '11%', },
    { label: getLangValue("product-template", "price"), width: '11%', },
    { label: getLangValue("product-template", "type"), width: '11%', },
    { label: getLangValue("product-template", "size"), width: '11%', },
    { label: getLangValue('product-management', "code_pid_gtin"), width: '11%', },
    { label: getLangValue("base.operation"), width: '9%', },
])
const pageSizeOption = [10, 20, 30, 40, 50]
const statusList = [
    { label: getLangValue("business-product", "tab1"), value: 0 },
    { label: getLangValue("business-product", "tab2"), value: 3 },
    { label: getLangValue("business-product", "testedSuccessfully"), value: 1 },
    { label: getLangValue("business-product", "certificationPassed"), value: 2 },
    { label: getLangValue("business-product", "updatedHSCode"), value: 4 },
    { label: getLangValue("business-product", "updatedTemplate"), value: 5 },
]
const { total, currentPage, pageSize, pageOption } = usetablePageNation()
const { alertInfo, openAlert, formValidataAlert } = useMessage()

// const templateName = ref("")
const searchInfo = reactive({
    keyword: '',  //产品名称
    publicType: route.query.p_id ? '' : 4, //公开类型
    status: '', //状态
    hscode: '', //hscode
    hscode_id: '', //hscode
    price: [], //价格
    inventory: [], //库存
    hand: [], //手感
    skin: [], //肤感
    heat: [],//热湿舒适度
    aesthetic_comfort: [],//热湿舒适度
    table_name: '',
    product_template_name: '',
    product_line_id: route.query.p_id ? route.query.p_id : '',
    hand_feeling_layer: '',
    supplier: '', // 供应商
    order_by: 'desc', //排序字段
    sort_field: 'name',
})
// const switchChange = (info) => {
//     //切换开关
//     console.log(info);
// }
// const getTemplateMenu = async () => {
//     const resp = await getProductTemplateMenu();
//     if (resp) {
//         // templateMenuList.value = resp.payload
//         // 获取type信息
//         if (route.params.id) {
//             const arr = resp.payload.filter(item => item.id == route.params.id)
//             if (arr.length) {
//                 searchInfo.table_name = arr[0].table_name
//                 // getDataList();
//             }
//         }
//     }
// }
// const getTableName = () => {
//     const arr = templateMenuList.value.filter(item => item.id == route.query.tid)
//     if (arr.length) {
//         searchInfo.table_name = arr[0].table_name
//         getDataList();
//     }
// }
const handler = (type, info) => {
    //按钮处理
    let url;
    switch (type) {
        case 'view':
            if (route.query.p_id) {
                url = router.resolve({
                    path: '/products_info', query: {
                        tid: route.params.id,
                        id: info.id,
                        d_id: info.database_id,
                        t_name: info.organization.table_name,
                        p_id: route.query.p_id,
                        p_l_no: route.query.p_l_no,
                        p_l_name: route.query.p_l_name,
                        p_l_name_en: route.query.p_l_name_en,
                        h_id: route.query.h_id,
                        p_o_o: route.query.p_o_o,
                        style: route.query.style,
                        pattern: route.query.pattern,
                        status: route.query.status,
                        role_key: route.query.role_key 
                    }
                }).href
            } else {
                url = router.resolve({
                    path: '/products_info', query: {
                        tid: route.params.id,
                        id: info.id,
                        d_id: info.database_id,
                        t_name: info.organization.table_name,
                        role_key: route.query.role_key 
                    }
                }).href
            }
            window.open(url, '_blank')
            break;
        case 'edit':
            if (route.query.p_id) {
                url = router.resolve({
                    name: 'products_detail', query: {
                        type: 'edit',
                        id: info.id,
                        d_id: info.database_id,
                        tid: route.params.id,
                        t_name: info.organization.table_name,
                        p_id: route.query.p_id,
                        p_l_no: route.query.p_l_no,
                        p_l_name: route.query.p_l_name,
                        p_l_name_en: route.query.p_l_name_en,
                        h_id: route.query.h_id,
                        p_o_o: route.query.p_o_o,
                        style: route.query.style,
                        pattern: route.query.pattern,
                        status: route.query.status,
                        from: window.location.href, // 从哪里来的
                        role_key: route.query.role_key 
                    }
                }).href
                window.open(url, '_blank')
            } else {
                url = router.resolve({
                    name: 'products_detail', query: {
                        type: 'edit',
                        id: info.id,
                        d_id: info.database_id,
                        tid: route.params.id,
                        t_name: info.organization.table_name,
                        from: window.location.href, // 从哪里来的
                        role_key: route.query.role_key
                    }
                }).href
                window.open(url, '_blank')
            }

            break;
        case 'delete':
            deleteData(info)
            break;
        case 'copy':
            copyData(info)
            break;
        // case 'contrast':
        //     contrastData(info)
        //     break;
    }
}

// const contrastData = (info) => {
//     // 获取对比信息数据
//     // visible.value = true;
//     visibleInfo.value.id = info.id;
//     visibleInfo.value.showCharts = showCharts1.value;
//     visibleInfo.value.searchInfo = searchInfo;
// }

const copyData = async (info) => {
    // const { database_id, organization } = info;
    const { id } = info;
    // const name = info['name']
    Swal.fire({
        title: getLangValue("base.copy_alert_title"),
        text: getLangValue("product-management", "message8"),
        icon: "info",
        showCancelButton: true,
        cancelButtonColor: "#f46a6a",
        confirmButtonColor: "#34c38f",
        confirmButtonText: getLangValue("base.done"),
        cancelButtonText: getLangValue("base.cancel"),
    }).then(async (result) => {
        if (result.isConfirmed) {
            //延迟2s操作
            // let resp = await copyProduct({ table_name: organization.table_name, database_id: database_id });
            let resp = await copyProduct({ id: id });
            if (resp) {
                openAlert({
                    variant: resp.code == 1 ? "danger" : 'success',
                    content: resp.code == 1 ? resp.message : getLangValue("base.copy_success"),
                });
                //  更新
                getDataList();
            }
        }
    });
}

const deleteData = async (info) => {
    // const { database_id } = info;
    // const name = info.product_info.children[0].children[0].value
    const name = info['name']
    Swal.fire({
        title: getLangValue("base.delete_alert_title") + `${i18n.global.locale == 'ch' ? name + '?' : ''}`,
        text: getLangValue("base.delete_alert_info"),
        icon: "warning",
        showCancelButton: true,
        cancelButtonColor: "#f46a6a",
        confirmButtonColor: "#34c38f",
        confirmButtonText: getLangValue("base.done"),
        cancelButtonText: getLangValue("base.cancel"),
    }).then(async (result) => {
        if (result.isConfirmed) {
            // console.log(id)
            //延迟2s操作
            // let resp = await deleteProduct(info.table_name, database_id);
            let resp = await deleteProduct(info.id);
            if (resp) {
                openAlert({
                    variant: resp.code == 1 ? "danger" : 'success',
                    content: resp.code == 1 ? resp.message : getLangValue("base.delete_success"),
                });
                //  更新
                getDataList();
            }
        }
    });
}

const getTemplateName = () => {
    // 获取role_key
    let data = sessionStorage.getItem('t_menuList') ? JSON.parse(sessionStorage.getItem('t_menuList')) : []
    if (data.length) {
        let arr = data.filter(item => item.id === route.params.id)
        let role_key = arr.length==1 ? arr[0].role_key : route.query.role_key || '';
        return role_key
    }
}

const getTemplateNameList = async () => {
    const resp = await database_template_name_v3()
    if (resp.code == 0) {
        templateNameList.value = resp.payload;
        // console.log(templateNameList.value);
    }
}

const getDataList = async () => {
    selectedInfo.value = {hide: true};
    let role_key = getTemplateName()
    if (!route.query.status && !role_key) return
    if (route.query.status == 1) {
        // 产品线的数据 因为有可能关闭  需要从全量模板获取
        if (templateNameList.value == 0) {
            await getTemplateNameList()
        }
        let obj = templateNameList.value.find(item => item.name === route.params.id)
        if (obj && obj.role_key) {
            // 获取role_key
            role_key = obj.role_key
        }

    }
    //获取数据
    let params = {
        page: currentPage.value - 1,
        limit: pageSize.value,
        product_name: searchInfo.keyword,
        role_key: role_key,
        production_line_id: route.query.p_id ? route.query.p_id : '',
        is_public: route.query.p_id ? 0 : 1,
        public_type: searchInfo.publicType,
        status: searchInfo.status,
        hand_feeling_layer: searchInfo.hand_feeling_layer,
        // table_name: searchInfo.table_name,
        supplier: searchInfo.supplier, // 供应商
        order_by: searchInfo.order_by, //排序字段
        sort_field: 'name', //排序字段
    }
    // if (!params.table_name) return
    // console.log(props.showSearch)
    if (props.showSearch) {
        params.hscode = searchInfo.hscode
        params.hscode_id = searchInfo.hscode_id
        params.price = JSON.stringify(searchInfo.price)
        params.inventory = JSON.stringify(searchInfo.inventory)
        params.hand_feeling = searchInfo.hand.length ? JSON.stringify(searchInfo.hand) : '[]'
        params.skin_feeling = searchInfo.skin.length ? JSON.stringify(searchInfo.skin) : '[]'
        params.heat_and_humidity_comfort = searchInfo.heat.length ? JSON.stringify(searchInfo.heat) : '[]'
        params.aesthetic_comfort = searchInfo.aesthetic_comfort.length ? JSON.stringify(searchInfo.aesthetic_comfort) : '[]'
    }
    loading.value = true
    const resp = route.query.p_id ? await getProductsListV3(params) : await getProductsList(params);
    loading.value = false
    if (resp.code == 0) {
        if (resp.payload.total == (currentPage.value - 1) * pageSize.value && currentPage.value > 1) {
            currentPage.value--
            return
        }
        tableInfo.value = resp.payload.data;
        tableInfo.value.forEach(async item => {
            if (item.pid) {
                const reps = route.query.p_id? await makeQrCode({ type: 2, id: item.id }):  await makeQrCode({ type: 2, id: item.id }, true)
                if (reps) {
                    item.qrcodeImgUrl = reps
                }
            }
        })
        // 需要根据筛选项公开类型选择使用哪个数据
        // 不公开 1
        // 仅对供应链公开 3 
        // 完全公开 2
        // if (searchInfo.publicType == '') {
        //     total.value = resp.payload.all_total
        // } else if (searchInfo.publicType == 1) {
        //     total.value = resp.payload.private_total
        // } else if (searchInfo.publicType == 2) {
        //     total.value = resp.payload.public_total
        // } else {
        //     total.value = resp.payload.supply_chain_public_total
        // }
        total.value = resp.payload.total
        emits('updateTabData', resp.payload)
    } else {
        openAlert({
            variant: "danger",
            content: resp.message,
        });
    }

}

const goDetail = (info) => {
    // router.push({ path: '/products_info', query: { tid: route.params.id, id: info.database_id, t_name: info.table_name } })
    if (!permission('my.product.show')) {
        return false
    }
    let url;
    if (route.query.p_id) {
        url = router.resolve({
            path: '/products_info', query: {
                tid: route.params.id,
                id: info.id,
                d_id: info.database_id,
                t_name: info.organization.table_name,
                p_id: route.query.p_id,
                p_l_no: route.query.p_l_no,
                p_l_name: route.query.p_l_name,
                p_l_name_en: route.query.p_l_name_en,
                h_id: route.query.h_id,
                p_o_o: route.query.p_o_o,
                style: route.query.style,
                pattern: route.query.pattern,
                status: route.query.status,  //模板状态  模板关闭后 不可以新增编辑
                role_key: route.query.role_key 
            }
        }).href
    } else {
        url = router.resolve({
            path: '/products_info', query: {
                tid: route.params.id,
                id: info.id,
                d_id: info.database_id,
                t_name: info.organization.table_name,
                role_key: route.query.role_key 
            }
        }).href
    }
    window.open(url, '_blank')
}
const checkCharts = () => {
    let data = sessionStorage.getItem('t_menuList') ? JSON.parse(sessionStorage.getItem('t_menuList')) : []
    let arr = data.filter(item => item.table_name === route.query.t_name)
    if (arr.length) {
        showCharts.value[0] = arr[0].enable_search_hand_feel
        showCharts.value[1] = arr[0].enable_search_skin_feel
        showCharts.value[2] = arr[0].enable_search_humidity_heat_comfort
    }
}

const showImageCode = (url) => {
    /**查看二维码大图 */
    activeImageSrc.value = url;
    if (activeImageSrc.value == "") {
        return;
    }
    showPreviewImg.value = true;
}

const getStatus = (status, public_type) => {
    // 完全公开的数据才会有审核转状态
    if (public_type == 2) {
        return statusList.filter(item => item.value == status)[0].label
    }
    return '-'
    // return statusList[Math.floor(Math.random() * 4)].label
}

const getPublic = (type) => {
    let data = [
        {
            label: getLangValue("product-management", "completelypublic"),
            value: 2
        },

        {
            label: getLangValue("product-management", "Opasc"),
            value: 3
        },
        {
            label: getLangValue("product-management", "notpublic"),
            value: 1
        },
    ]
    if (data.length) {
        let arr = data.filter(item => item.value === type)
        if (arr.length) {
            return arr[0].label
        }
    }
    return ''
}


const changCheckBox =(id)=> {
    // 选择当前数据 只能选一条
    // tableInfo.value.forEach(item => {
    //     if (item.id == id) {
    //         if(typeof item.checked == 'undefined') {
    //             item.checked = true
    //         }else{
    //             item.checked =!item.checked
    //         }
    //     } else {
    //         item.checked = false
    //     }
    // })
    let arr = tableInfo.value.filter(item=> item.checked)
    if(arr.length > 1) {
        // 只保留当前id
        tableInfo.value.forEach(item => {
            item.checked = false
        })
        tableInfo.value.find(item=> item.id == id).checked = true
    }
    let obj = tableInfo.value.find(item=> item.checked)
    selectedInfo.value = obj? obj: {hide: true}; // hide 用于关闭对比图表
    // console.log(selectedInfo.value);
}

// const toggletAll =()=> {
//     // 全选或反选
//     tableInfo.value.forEach(item => {
//         if (checkedAll.value) {
//             item.checked1 = true
//         } else {
//             item.checked1 = false
//         }
//     })
// }

watch(pageSize, () => {
    currentPage.value = 1;
    getDataList()
})

watch(tableInfo, () => {
    fileList.value = []
    let imageList = tableInfo.value.filter(item => item['picture'].length > 0).map((item) => item['picture'][0])
    // 重复图片 去重
    imageList = [...new Set(imageList)]
    let imgStr = imageList.join(',')
    if (imgStr)
        getFileUrl({ attachments: imgStr }).then(resp => {
            if (resp) {
                fileList.value = resp.payload
                // console.log(fileList.value);
            }
        })

},)

watch(currentPage, () => {
    getDataList();
})

watch(searchInfo, () => {
    currentPage.value = 1;
    getDataList();
}, { deep: true })

watch(() => route.params.id, () => {
    // getTemplateMenu();
    if (route.query.t_name) {
        searchInfo.table_name = route.query.t_name;
        // 获取product_template_name  
    }
    searchInfo.publicType = route.query.p_id ? '' : 4
    getDataList()
    // checkCharts()
}, { deep: true, })
watch(() => route.query, () => {
    if (route.query.p_id) {
        // 我的产品进入
        table_head.value = [
            { label: getLangValue("product-management", "title"), width: '10%',  sortable: true},
            { label: getLangValue("product-template", "publicType"), width: '9%', },
            { label: getLangValue("product-management", "status"), width: '9%', },
            { label: getLangValue("product-template", "color"), width: '9%', },
            { label: getLangValue("product-template", "inventory"), width: '9%', },
            { label: getLangValue("product-template", "price"), width: '9%', },
            { label: getLangValue("product-template", "type"), width: '9%', },
            { label: getLangValue("product-template", "size"), width: '9%', },
            { label:getLangValue('product-management', "code_pid_gtin"), width: '9%', },
            { label: getLangValue("base.operation"), width: '9%', },
        ]
        tableType.value = 0
    } else {
        table_head.value = [
            { label: getLangValue("product-management", "title"), width: '10%',  sortable: true},
            { label: getLangValue("home.supplier"), width: '10%', },
            { label: getLangValue("product-template", "color"), width: '10%', },
            { label: getLangValue("product-template", "inventory"), width: '10%', },
            { label: getLangValue("product-template", "price"), width: '10%', },
            { label: getLangValue("product-template", "type"), width: '10%', },
            { label: getLangValue("product-template", "size"), width: '10%', },
            { label:getLangValue('product-management', "code_pid_gtin"), width: '10%', },
            { label: getLangValue("base.operation"), width: '9%', },
            // { label: 'check', width: '1%', },
        ]
        tableType.value = 1
    }
})

const sort = () => {
    // 处理现在表格的数据
    let dom = document.querySelector('.sortable')
    let classList = dom.classList
    if (classList.value.includes('desc')) {
        // 现在是倒叙 变为升序
        classList.remove('desc')
        classList.add('asc')
        searchInfo.order_by = 'asc'
    } else {
        // 现在是升序 变为降序
        classList.remove('asc')
        classList.add('desc')
        searchInfo.order_by = 'desc'
    }
    getDataList()
}

const getName = (name) => {
    // 处理产品名称 如果里面有复制 如果是中文则不管 如果是英文则全部替换为copy
    if (name.includes('复制') && i18n.global.locale == 'en') {
        name = name.replaceAll('复制', 'copy')
    }
    return name
}

onMounted(() => {
    searchInfo.table_name = route.query.t_name;
    // getDataList();
    checkCharts();
    // 设置表头   菜单进入显示的是供应商的信息     从我的产品进入显示的是 数据公开类型  审核状态
    if (route.query.p_id) {
        // 我的产品进入
        table_head.value = [
            { label: getLangValue("product-management", "title"), width: '10%',  sortable: true},
            { label: getLangValue("product-template", "publicType"), width: '8%', },
            { label: getLangValue("product-management", "status"), width: '8%', },
            { label: getLangValue("product-template", "color"), width: '8%', },
            { label: getLangValue("product-template", "inventory"), width: '8%', },
            { label: getLangValue("product-template", "price"), width: '8%', },
            { label: getLangValue("product-template", "type"), width: '8%', },
            { label: getLangValue("product-template", "size"), width: '8%', },
            { label:getLangValue('product-management', "code_pid_gtin"), width: '8%', },
            { label: getLangValue("base.operation"), width: '8%', },
        ]
        tableType.value = 0
    } else {
        table_head.value = [
            { label: getLangValue("product-management", "title"), width: '10%',  sortable: true},
            { label: getLangValue("home.supplier"), width: '10%', },
            { label: getLangValue("product-template", "color"), width: '10%', },
            { label: getLangValue("product-template", "inventory"), width: '10%', },
            { label: getLangValue("product-template", "price"), width: '10%', },
            { label: getLangValue("product-template", "type"), width: '10%', },
            { label: getLangValue("product-template", "size"), width: '10%', },
            { label:getLangValue('product-management', "code_pid_gtin"), width: '10%', },
            { label: getLangValue("base.operation"), width: '9%', },
            // { label: 'check', width: '1%', },
        ]
        tableType.value = 1
    }
})
//弹出
defineExpose({
    searchInfo,
    getDataList,
    tableInfo,
    loading
})
</script>

<template>
    <div class="form px-0  bg-white d-flex" v-if="tableInfo.length || loading"
        style="height: 100%; flex-direction: column; border-radius: 0.25rem;">
        <!-- Bordered Tables -->
        <!-- <div style="height:calc(100% - 60px - 1rem); overflow-y: auto;" class="my-scroll-bar"> -->
        <div style="overflow-x: auto; width: 100%; overflow-y: auto; flex: 1;" class="my-scroll-bar">
            <table class="table table-bordered table-nowrap mb-0" v-loading="loading">
                <thead class="table-light ">
                    <tr>
                        <th scope="col" style="color: #9599AD;" width="1%">#</th>
                        <th scope="col" v-for="(head, index) in table_head" :key="index" style="color: #9599AD;"
                            :width="head.width">
                             <div class="d-flex align-items-center" style="height: 36px;">
                                {{ head.label }}
                                <div class="sortable mx-2 cursor-pointer desc" v-if="head.sortable"
                                    style="position: relative; width: 14px; height: 10px;" @click="sort"></div>
                            </div>
                            <!-- <input @change="toggletAll" v-model="checkedAll"  v-else class="form-check-input" type="checkbox"  aria-label="Checkbox for following text input"> -->
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(info, index) in tableInfo" :key="index" style="vertical-align: middle">
                        <!-- <td style="text-align: left;">{{ index + 1 }}</td> -->
                        <td>
                            <input v-show="searchInfo.hand.length || searchInfo.skin.length || searchInfo.heat.length || searchInfo.aesthetic_comfort.length" @change="changCheckBox(info.id)" class="form-check-input mt-0" type="checkbox"
                                v-model="info.checked" aria-label="Checkbox for following text input">
                        </td>
                        <td>
                            <a @click="goDetail(info)">
                                <div class="d-flex cursor-pointer">
                                    <div class="avatar-sm bg-light rounded p-1 me-3">
                                        <!-- <img src="assets/images/products/img-1.png" alt="" class="img-fluid d-block"> -->
                                        <img style="width: 40px; height: 40px;"
                                            :src="info['picture'].length && fileList.length ? fileList.filter(item => item.id === info['picture'][0]).length ? fileList.filter(item => item.id === info['picture'][0])[0].url : '' : ''">
                                    </div>
                                    <div class="flex-1 me-2">
                                        <div :class="i18n.global.locale == 'en' ? 'en-word-break' : 'zh-word-break'"
                                            style="font-weight: 500; font-size: 14px; font-family: Poppins; margin-bottom: 0.2rem;max-width: 200px;white-space: normal;">
                                            {{
                                                getName(info['name']) }}</div>
                                        <div style="color: rgba(149, 153, 173, 1);">HS Code：{{
                                            i18n.global.locale == 'en' ? info.hscode?.title_en : info.hscode?.title }}
                                        </div>
                                    </div>
                                </div>
                            </a>
                        </td>
                        <td :class="i18n.global.locale == 'en' ? 'en-word-break' : 'zh-word-break'"
                            style="max-width: 150px; white-space: normal;" v-if="tableType ==1">{{
                                info.organization ? info.organization.company_name : '' }}
                        </td>
                        <td :class="i18n.global.locale == 'en' ? 'en-word-break' : 'zh-word-break'"
                            style="max-width: 150px; white-space: normal;" v-else>{{ getPublic(info.public_type) }}</td>
                        <td :class="i18n.global.locale == 'en' ? 'en-word-break' : 'zh-word-break'"
                            style="max-width: 150px; white-space: normal;" v-if="tableType<1">{{
                                getStatus(info.status, info.public_type) }}</td>
                        <td>{{ info['color'] }}</td>
                        <td>{{ info['inventory'] }}</td>
                        <td>
                            <span style="margin-right: 1px;">{{ info['price_unit'] }}</span>
                            {{ info['price'] }}
                        </td>
                        <td>{{ info['type'] }}</td>
                        <td>{{ info['size'] }}</td>
                        <td>
                            <!-- {{ info['pid'] }} -->
                            <img class="cursor-pointer" :src="info.qrcodeImgUrl" v-if="info.qrcodeImgUrl"
                                style="width: 40px;" @click="showImageCode(info.qrcodeImgUrl)" />
                        </td>
                        <td>
                            <template class="d-flex align-items-center">
                                <div class="dropdown"
                                    style="background-color: rgba(53, 119, 241, 0.098); text-align: center; width: 30px; height: 30px; line-height: 30px;">
                                    <a style="display: block; width: 100%; height: 100%;" href="#" role="button"
                                        id="dropdownMenuLink" data-bs-toggle="dropdown" aria-expanded="false"><i
                                            class="ri-more-line"></i></a>
                                    <ul class="dropdown-menu" aria-labelledby="dropdownMenuLink">
                                        <li v-permit="'my.product.show'">
                                            <div class="dropdown-item cursor d-flex align-items-center"
                                                @click="handler('view', info)">
                                                <i class="fs-16 ri-eye-fill text-primary me-2"></i> {{
                                                    getLangValue("base.to_view") }}
                                            </div>
                                        </li>
                                        <li v-if="route.query.p_id && (route.query.status == 1)">
                                            <div v-permit="'my.product.modify'"
                                                class="dropdown-item cursor d-flex align-items-center"
                                                @click="handler('edit', info)">
                                                <i class="fs-16 ri-pencil-fill text-primary me-2"></i> {{
                                                    getLangValue("base.edit") }}
                                            </div>
                                        </li>
                                        <li v-if="route.query.p_id && info.flag !== 1">
                                            <div v-permit="'my.product.copy'"
                                                class="dropdown-item cursor d-flex align-items-center"
                                                @click="handler('copy', info)">
                                                <i class="fs-16 bx bx-copy text-primary me-2"
                                                    style="transform: rotate(90deg); color:black"></i>{{
                                                        getLangValue("base.copy")
                                                    }}
                                            </div>
                                        </li>
                                        <!-- <li >
                                            <div v-permit="'my.product.show'"
                                                class="dropdown-item cursor d-flex align-items-center"
                                                @click="handler('contrast', info)">
                                               {{getLangValue("product-management.contrast")}}
                                            </div>
                                        </li> -->
                                        <li class="dropdown-divider" v-permit="'my.product.delete'"
                                            v-if="route.query.p_id"></li>
                                        <li v-if="route.query.p_id">
                                            <div v-permit="'my.product.delete'"
                                                class="dropdown-item cursor d-flex align-items-center"
                                                @click="handler('delete', info)">
                                                <i class="fs-16 ri-delete-bin-5-fill text-danger me-2"></i>{{
                                                    getLangValue("base.delete") }}
                                            </div>
                                        </li>

                                    </ul>
                                </div>
                                <i v-if="info.flag === 1 && route.query.p_id" class="ri-indeterminate-circle-line ms-2"
                                    style="font-size: 30px;color: #ED4014;"></i>
                            </template>
                        </td>
                        <!-- <td v-if="tableType==1">
                            <input v-model="info.checked1"  class="form-check-input" type="checkbox"  aria-label="Checkbox for following text input">
                        </td> -->
                    </tr>
                </tbody>
            </table>
        </div>
        <!-- 分页 -->
        <Pagination v-if="total" v-model:page="currentPage" v-model:perPage="pageSize" :pages="pageOption"
            :prePageOption="pageSizeOption" :tab_info_length="total" class="me-5"
            style="margin-top: 0 !important;border-radius: 0.25rem;">
        </Pagination>
    </div>
    <div style="height: 100%;" v-else class="d-flex align-items-center justify-content-center">
        <Empty style="margin-top: 200px;"></Empty>
    </div>
    <PreviewImg v-model:showPreviewImg="showPreviewImg" :src="activeImageSrc" :myWidth="400" v-if="showPreviewImg">
    </PreviewImg>
    <message-alert :alertInfo="alertInfo" v-if="formValidataAlert"></message-alert>
</template>
<style scoped>
.table-bordered> :not(caption)>*>* {
    border: unset;
}

.table-bordered td {
    padding: 0.35rem 0.6rem !important;
}

.table-bordered th {
    padding: 0.5rem 0.6rem !important;
}
.sortActive {
    color: black;
}
.sortable {
    &::after {
        content: "\f035d";
        position: absolute;
        right: .5rem;
        top: 0px;
        font-size: .8rem;
        font-family: "Material Design Icons";
    }

    &::before {
        content: "\f0360";
        position: absolute;
        right: .5rem;
        top: -8px;
        font-size: .8rem;
        font-family: "Material Design Icons";
    }
}
.desc {
    &::after {
        color: black;
    }
}

.asc {
    &::before {
        color: black;
    }
}
</style>